import { render, staticRenderFns } from "./ForumThreadPageContent.vue?vue&type=template&id=b3f402a2&scoped=true"
import script from "./ForumThreadPageContent.vue?vue&type=script&lang=js"
export * from "./ForumThreadPageContent.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadPageContent.vue?vue&type=style&index=0&id=b3f402a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f402a2",
  null
  
)

export default component.exports